import React from 'react';
import {
  ActivityIndicatorProps,
  ActivityIndicator as BaseActivityIndicator,
  Platform,
  StyleSheet,
  View,
} from 'react-native';
import { useTheme } from '@/contexts/theme-context';

export const ActivityIndicator: React.FC<ActivityIndicatorProps> = ({
  // Make the color transparent so it works on both light and dark backgrounds
  color,
  ...rest
}) => {
  const theme = useTheme();
  const content = (
    <BaseActivityIndicator
      accessibilityRole="progressbar"
      accessibilityState={{ busy: true }}
      accessible
      color={color ?? `${theme.colors.inactiveText}bb`}
      {...rest}
    />
  );

  // Large ActivityIndicator renders slightly off center on iOS
  // https://stackoverflow.com/a/35561679
  return Platform.OS === 'ios' && rest.size === 'large' ? (
    <View style={styles.largeContainer}>{content}</View>
  ) : (
    content
  );
};

const styles = StyleSheet.create({
  largeContainer: {
    left: 1.5,
    position: 'relative',
    top: 1.5,
  },
});
